import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-social-media-link',
  templateUrl: './social-media-link.component.html',
  styleUrls: ['./social-media-link.component.scss']
})
export class SocialMediaLinkComponent implements OnInit {
  @Input() type: string;
  @Input() icon: string;
  @Input() link: string;
  @Input() name: string;

  constructor() {
  }

  ngOnInit() {
  }

}
